import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../auth/AuthContext';
import { startDirectMessage } from '../../../utils/messages';
export default function AdminListCard({
  admins,
  enableMessages = false,
  teamId = null
}) {
  const navigate = useNavigate();
  const {
    user
  } = useAuth();
  const handleMessageClick = async admin => {
    try {
      const thread = await startDirectMessage(user, admin, teamId);
      navigate(`/messages/${thread.id}`);
    } catch (err) {
      alert('Could not start conversation.');
    }
  };
  return <div className="team-card">
      <div className="card-header-with-icon">
        <span className="card-title">Admins ({admins.length})</span>
      </div>
      <div className="card-body">
        <ul className="list-disc list-inside">
          {admins.map(admin => <li key={admin.id} style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '0.25rem 0'
        }}>
              <span>{admin.name}</span>
              {enableMessages && <button type="button" onClick={event => {
            event.stopPropagation();
            handleMessageClick(admin);
          }} aria-label={`Message ${admin.name}`} title={`Message ${admin.name}`} className="message-button" style={{
            background: 'none',
            border: 'none',
            padding: 6,
            cursor: 'pointer'
          }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M2 3h20v18l-4-4H2V3zm2 2v10h13.17L20 18.17V5H4z" />
                  </svg>
                </button>}
            </li>)}
        </ul>
      </div>
    </div>;
}
